<template>
  <div class="container py-5" style="max-width: 400px">
    <h2 class="mb-4 text-center">Redefinir senha</h2>

    <form @submit.prevent="redefinir">
      <div class="mb-3">
        <label for="senha" class="form-label">Nova senha</label>
        <input
          type="password"
          v-model="senha"
          class="form-control"
          id="senha"
          required
        />
      </div>

      <div class="mb-3">
        <label for="senha2" class="form-label">Confirmar nova senha</label>
        <input
          type="password"
          v-model="senha2"
          class="form-control"
          id="senha2"
          required
        />
      </div>

      <button type="submit" class="btn btn-primary w-100">
        Salvar nova senha
      </button>
    </form>

    <p v-if="mensagem" class="mt-3 text-success">
      {{ mensagem }}
    </p>

    <p v-if="erro" class="mt-3 text-danger">
      {{ erro }}
    </p>

    <router-link to="/login" class="d-block mt-3 text-center">
      Voltar para o login
    </router-link>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  name: "RedefinirSenhaVie",
  data() {
    return {
      senha: "",
      senha2: "",
      token: this.$route.query.token || "",
      mensagem: "",
      erro: "",
    };
  },
  methods: {
    async redefinir() {
      this.mensagem = "";
      this.erro = "";

      if (!this.token) {
        this.erro = "Token de redefinição não encontrado.";
        return;
      }

      if (this.senha !== this.senha2) {
        this.erro = "As senhas não conferem.";
        return;
      }

      try {
        const response = await api.post("redefinir_senha.php", {
          token: this.token,
          senha: this.senha,
        });

        this.mensagem = response.data.mensagem || "Senha redefinida com sucesso.";
      } catch (error) {
        this.erro =
          error?.response?.data?.erro ||
          "Não foi possível redefinir sua senha. Tente novamente.";
      }
    },
  },
};
</script>
